import {
  Factory, Truck, Store, ShoppingCart, Package, HeartPulse, FlaskConical, Landmark, Wallet,
  ShieldCheck, AppWindow, Server, GraduationCap, Building2, Hotel, UtensilsCrossed, Sprout, Zap,
  RadioTower, Clapperboard, Car, Shirt, Scale, Megaphone, Users, Building, HandHeart, Shapes
} from "lucide-react";

// Maps icon names stored in the `industries` table to lucide components.
const INDUSTRY_ICONS = {
  Factory, Truck, Store, ShoppingCart, Package, HeartPulse, FlaskConical, Landmark, Wallet,
  ShieldCheck, AppWindow, Server, GraduationCap, Building2, Hotel, UtensilsCrossed, Sprout, Zap,
  RadioTower, Clapperboard, Car, Shirt, Scale, Megaphone, Users, Building, HandHeart, Shapes
};

export const industryIcon = (name) => INDUSTRY_ICONS[name] || Shapes;
